<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet">
        <defs>
            <clipPath :id="`clip-path-${uniqueId}`">
                <rect id="Rectangle_243" data-name="Rectangle 243" width="48" height="48" rx="6" fill="#fff" />
            </clipPath>
        </defs>
        <g
            id="Icons_I_payment_transparent_mastercard"
            data-name="Icons / I_payment_transparent_mastercard"
            :clip-path="`url(#clip-path-${uniqueId})`">
            <rect id="Rectangle_241" data-name="Rectangle 241" width="48" height="48" rx="6" fill="rgba(0,0,0,0)" />
            <rect
                id="Rectangle_242"
                data-name="Rectangle 242"
                width="46"
                height="46"
                rx="5.5"
                transform="translate(1 1)"
                fill="none"
                stroke="rgba(255,255,255,0)"
                stroke-width="1" />
            <g id="Group_1438" data-name="Group 1438" transform="translate(9 15)">
                <path
                    id="Path_299"
                    data-name="Path 299"
                    d="M13.617,25.5a9,9,0,0,0,0-18,9,9,0,1,0,0,18Z"
                    transform="translate(-4.5 -7.5)"
                    fill="#e7001a"
                    fill-rule="evenodd" />
                <path
                    id="Path_300"
                    data-name="Path 300"
                    d="M19.617,25.5a9,9,0,0,0,0-18,9,9,0,1,0,0,18Z"
                    transform="translate(1.5 -7.5)"
                    fill="#f49b1c"
                    fill-rule="evenodd" />
                <path
                    id="Path_301"
                    data-name="Path 301"
                    d="M13.518,8.652A9.079,9.079,0,0,0,10.5,15.465a8.784,8.784,0,0,0,3.018,6.6,8.878,8.878,0,0,0,2.982-6.6A9.178,9.178,0,0,0,13.518,8.652Z"
                    transform="translate(1.5 -6.348)"
                    fill="#e7001a"
                    fill-rule="evenodd"
                    opacity="0.3" />
            </g>
            <g
                id="Group_1439"
                data-name="Group 1439"
                transform="translate(9 15)"
                style="mix-blend-mode: color; isolation: isolate">
                <path
                    id="Path_299-2"
                    data-name="Path 299"
                    d="M13.617,25.5a9,9,0,0,0,0-18,9,9,0,1,0,0,18Z"
                    transform="translate(-4.5 -7.5)"
                    fill="#bfbca5"
                    fill-rule="evenodd" />
                <path
                    id="Path_300-2"
                    data-name="Path 300"
                    d="M19.617,25.5a9,9,0,0,0,0-18,9,9,0,1,0,0,18Z"
                    transform="translate(1.5 -7.5)"
                    fill="#bfbca5"
                    fill-rule="evenodd" />
                <path
                    id="Path_301-2"
                    data-name="Path 301"
                    d="M13.518,8.652A9.079,9.079,0,0,0,10.5,15.465a8.784,8.784,0,0,0,3.018,6.6,8.878,8.878,0,0,0,2.982-6.6A9.178,9.178,0,0,0,13.518,8.652Z"
                    transform="translate(1.5 -6.348)"
                    fill="#bfbca5"
                    fill-rule="evenodd"
                    opacity="0.3" />
            </g>
        </g>
    </svg>
</template>

<script lang="ts" setup>
    const uniqueId = useId();
</script>
